import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { RulesetMetricRuleCard } from '../../Notification/Rulesets/MetricRuleCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const RulesetMetricRuleCardWidget = () => {
    const component = useMemo(() => (_jsx(RulesetMetricRuleCard, { metricRule: {
            name: 'Metric rule',
            enabled: true,
            deviceEnabledType: '',
            key: '',
            valueType: 'latest',
            max: {
                value: undefined,
                datapoints: undefined,
                period: undefined,
                unit: undefined,
            },
            min: {
                value: undefined,
                datapoints: undefined,
                period: undefined,
                unit: undefined,
            },
            stdDev: {
                value: undefined,
                datapoints: undefined,
                period: undefined,
                unit: undefined,
            },
        }, metricKeysEnum: {}, ruleAttributes: {}, setMetricRule: (metricRule) => {
            // set this metric rule in the parent ruleset here
        }, removeArrayObjectNInParent: () => {
            // remove this metric rule from the parent ruleset here
        } })), []);
    return {
        name: 'RulesetMetricRuleCard',
        category: 'common',
        component,
    };
};
